import { useEffect, useRef } from "react";
import { usePropertyStore } from "../contexts/PropertyStoreContext";

const useReloadOnPropertyChange = () => {
  const { selectedProperty } = usePropertyStore();
  const previousPropertyCodeRef = useRef(null);

  useEffect(() => {
    const currentPropertyCode = selectedProperty?.propertyCode;

    if (previousPropertyCodeRef.current === null) {
      previousPropertyCodeRef.current = currentPropertyCode;
      return;
    }

    if (
      currentPropertyCode &&
      previousPropertyCodeRef.current !== currentPropertyCode
    ) {
      globalThis.location.reload?.();
    }
  }, [selectedProperty?.propertyCode]);
};

export default useReloadOnPropertyChange;
